<template>
  <div class="switches">
    <div class="switches__switch">
      <div class="switches__title">{{ store.translations.ConversionTitle }}</div>
      <div class="switches__subtitle" v-if="!store.metric && store.currentLanguage === 'en'">
        <span v-if="store.calculateSeedVolume">{{ store.translations.ConversionPopulationSubTitle }}</span>
        <span v-else>{{ store.translations.ConversionVolumeSubTitle }}</span>
      </div>
      <div class="switches__buttons">
        <div class="switches__button" :class="{ active: store.calculateSeedVolume }" role="button"
             @click="store.setSeedVolumeActive">
          <div class="switches__button-text">
            {{ store.translations.SeedVolume }}
            <div class="switches__button-unit">
              <span v-if="store.metric">({{ store.translations.Kg }}/{{ store.translations.Ha }})</span>
              <span v-else>({{ store.translations.Pounds }}/{{ store.translations.Acres }})</span>
            </div>
          </div>
        </div>

        <div class="switches__icon">
          <div class="icon icon--arrow-new-left" :class="{ active: store.calculateSeedVolume }"></div>
        </div>

        <div class="switches__button" :class="{ active: !store.calculateSeedVolume }" role="button"
             @click="store.setSeedPopulationActive">
          <div class="switches__button-text">
            {{ store.translations.SeedPopulation }}
            <div class="switches__button-unit">
              <span v-if="store.metric">({{ store.translations.Plants }}/{{ store.translations.M2 }})</span>
              <span v-else>({{ store.translations.Plants }}/{{ store.translations.Ft2 }})</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {useSeedRateCalculatorStore} from '../store/store.js';

const store = useSeedRateCalculatorStore();

</script>